export const RESET = 'DATABASECONNECTION_UPDATE_RESET'
export const SET_ERROR = 'DATABASECONNECTION_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'DATABASECONNECTION_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'DATABASECONNECTION_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'DATABASECONNECTION_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'DATABASECONNECTION_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'DATABASECONNECTION_UPDATE_UPDATE_RETRIEVED'
